/**
 * AddCustomerNote renders a button which when clicked renders a text areas for entering in a customer note to be added to a sale.
 * @param {string} note - Note that is currently in cart for the sale, default is an empty string.
 * @param {function} handleUpdateCustomerNote - A function to invoke when note is input.
 */
import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import PropTypes from "prop-types"
import React from "react"

class AddCustomerNote extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      customerNote: this.props.note,
      customerNoteOpen: !!this.props.note,
    }
    this.handleInputNote = this.handleInputNote.bind(this)
    this.toggleCustomerNoteOpen = this.toggleCustomerNoteOpen.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.note !== this.props.note) {
      this.setState({
        customerNote: this.props.note === null ? "" : this.props.note,
      })
    }
  }

  handleInputNote(note) {
    const trimmedNote = note.trim()
    const saveableNote = trimmedNote.length === 0 ? null : trimmedNote

    this.setState({ customerNote: note })
    this.props.handleUpdateCustomerNote(saveableNote)
  }

  toggleCustomerNoteOpen() {
    if (this.state.customerNoteOpen) {
      this.setState({ customerNoteOpen: false })
      this.handleInputNote("")
    } else {
      this.setState({ customerNoteOpen: true })
    }
  }

  renderAddNote() {
    if (this.state.customerNoteOpen || this.state.customerNote) {
      return (
        <div className="flex flex-col items-end pt-6">
          <button
            className="z-10 -mb-6 bg-transparent text-sm"
            aria-label="clear and close"
            type="button"
            onClick={() => this.toggleCustomerNoteOpen()}
          >
            <i className="icon icon-sf-trashcan text-gray-600" />
          </button>
          <FormGroup
            className="w-full"
            maxLength="500"
            inputType="textarea"
            label="Message to Customer (customer facing)"
            name="customerNote"
            value={this.state.customerNote}
            onChange={(event) => this.handleInputNote(event.target.value)}
          />
        </div>
      )
    } else {
      return (
        <div className="flex justify-end pt-4">
          <button
            type="button"
            className="text-link font-semibold"
            onClick={() => this.toggleCustomerNoteOpen()}
          >
            Add Message to Customer
          </button>
        </div>
      )
    }
  }

  render() {
    return <div>{this.renderAddNote()}</div>
  }
}

AddCustomerNote.propTypes = {
  note: PropTypes.string,
  handleUpdateCustomerNote: PropTypes.func.isRequired,
}

export default AddCustomerNote
